import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any[];
  FULL_DAY: any[];
  HALF_DAY: any[];
}

export enum TYPE_LEAVE {
  FULL_DAY = "FULL_DAY",
  HALF_DAY = "HALF_DAY",
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  FULL_DAY: [],
  HALF_DAY: [],
  data: [],
};

const getReasonLeaveSlice = createSlice({
  name: "getReasonLeave",
  initialState,
  reducers: {
    getReasonLeaveStart: (state, action: { payload: TYPE_LEAVE }) => {
      state.status = ReduxStateType.LOADING;
    },
    getReasonLeaveSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    updateListReason: (state, action) => {
      state[action.payload.type] = action.payload.data;
    },
    getReasonLeaveFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetReasonLeave: () => {
      return { ...initialState };
    },
  },
});

export const {
  getReasonLeaveStart,
  getReasonLeaveSuccess,
  getReasonLeaveFailed,
  resetReasonLeave,
  updateListReason,
} = getReasonLeaveSlice.actions;

export default getReasonLeaveSlice.reducer;
